var _ellipse, _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconRejectedStatus(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 37,
    viewBox: "0 0 36 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 18,
    cy: 18.0705,
    rx: 18,
    ry: 18.0705,
    fill: "#FFF3F4"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 16.6836C17.4 16.6836 17 16.9693 17 17.3979V20.9693C17 21.3979 17.4 21.6836 18 21.6836C18.6 21.6836 19 21.3979 19 20.9693V17.3979C19 16.9693 18.6 16.6836 18 16.6836Z",
    fill: "#E83647"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18 15.6836C18.5523 15.6836 19 15.2359 19 14.6836C19 14.1313 18.5523 13.6836 18 13.6836C17.4477 13.6836 17 14.1313 17 14.6836C17 15.2359 17.4477 15.6836 18 15.6836Z",
    fill: "#E83647"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18 9.68359C13.6 9.68359 10 13.2836 10 17.6836C10 22.0836 13.6 25.6836 18 25.6836C22.4 25.6836 26 22.0836 26 17.6836C26 13.2836 22.4 9.68359 18 9.68359ZM18 24.0836C14.48 24.0836 11.6 21.2036 11.6 17.6836C11.6 14.1636 14.48 11.2836 18 11.2836C21.52 11.2836 24.4 14.1636 24.4 17.6836C24.4 21.2036 21.52 24.0836 18 24.0836Z",
    fill: "#E83647"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconRejectedStatus);
export default __webpack_public_path__ + "static/media/icon-rejected-status.1cbbcb661241d40b2bf7547a10b4e6c6.svg";
export { ForwardRef as ReactComponent };